import formatDate from './formatDate';
import horario from './horario';

const extractTime = (date) => {
  let tempDate = new Date(date);
  const offset = tempDate.getTimezoneOffset() / 60;

  tempDate.setHours(tempDate.getHours() + offset);
  return `${tempDate.getHours()}:${tempDate
    .getMinutes()
    .toString()
    .padStart('2', '0')}`;
};

const scheduleTime = (solicitacao) => {
  if (
    solicitacao?.compromissoServico?.earliestStartTime &&
    solicitacao.tipo !== 'Assistência Técnica'
  ) {
    return `${formatDate(solicitacao?.compromissoServico?.earliestStartTime)} - 
    
    ${extractTime(solicitacao?.compromissoServico?.earliestStartTime)}
    às
    ${extractTime(solicitacao?.compromissoServico?.schedEndTime)}
    `;
  } else if (solicitacao?.compromissoServico?.earliestStartTime) {
    return `${formatDate(solicitacao?.compromissoServico?.earliestStartTime)} -
      ${horario(
        solicitacao?.compromissoServico?.earliestStartTime,
        solicitacao?.compromissoServico?.schedEndTime
      )}`;
  } else if (
    solicitacao?.agendamento &&
    solicitacao.tipo === 'Assistência Técnica'
  ) {
    return `${formatDate(solicitacao?.agendamento)} 
    -
      ${solicitacao?.horario.split(' - ')[0]}`;
  } else if (solicitacao?.agendamento) {
    return `${formatDate(solicitacao?.agendamento)} 
    -
      ${solicitacao?.horario}`;
  }
  return 'Não elegível';
};

export default scheduleTime;
